import lang from './lang';
import pageTitle from './pageTitle';
import logout from './logout';
import subscribes from './subscribes';

export default {
    lang,
    pageTitle,
    logout,
    subscribes,
};
